import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import { SubTabs } from '@/components/shared/SubTabs';
import { PageSubTabsProvider } from '@/hooks/usePageSubTabs';
import { useTranslator } from '@/hooks/useTranslator';

export const Route = createFileRoute(
  '/(client)/product-mapping/(pages)/(list)',
)({
  component: ProductMappingListLayout,
});

function ProductMappingListLayout() {
  const { getTranslation: t } = useTranslator({ page: 'product-mapping' });

  return (
    <PageSubTabsProvider
      tabs={
        <SubTabs
          tabs={[
            {
              key: 'active',
              label: t('toggle.active'),
              to: '/product-mapping/active',
            },
            {
              key: 'archive',
              label: t('toggle.archive'),
              to: '/product-mapping/archive',
            },
          ]}
        />
      }
    >
      <PageContainer>
        <Outlet />
      </PageContainer>
    </PageSubTabsProvider>
  );
}
